<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  components: {
    NextButton,
  },
  props: {
    user: {
      type: String,
      default: '',
    },
    pass: {
      type: String,
      default: '',
    },
  },
  emits: ['updateVoipSettings'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      voipUser: this.user,
      voipPass: this.pass,
      inputStyles: {
        borderRadius: '0.75rem',
        padding: '0.375rem 0.75rem',
        fontSize: '0.875rem',
        marginBottom: '0.125rem',
      },
    };
  },
  validations: {
    voipUser: { required },
    voipPass: { required },
  },
  watch: {
    user(value) {
      this.voipUser = value;
    },
    pass(value) {
      this.voipPass = value;
    },
  },
  methods: {
    async updateVoipSettings() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        useAlert(this.$t('PROFILE_SETTINGS.FORM.ERROR'));
        return;
      }

      this.$emit('updateVoipSettings', {
        user: this.voipUser,
        pass: this.voipPass,
      });
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="updateVoipSettings">
    <woot-input
      v-model="voipUser"
      :styles="inputStyles"
      :class="{ error: v$.voipUser.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.VOIP.USER.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.VOIP.USER.PLACEHOLDER')"
      :error="`${v$.voipUser.$error ? $t('PROFILE_SETTINGS.FORM.VOIP.USER.ERROR') : ''}`"
      @input="v$.voipUser.$touch"
      @blur="v$.voipUser.$touch"
    />
    <woot-input
      v-model="voipPass"
      type="password"
      :styles="inputStyles"
      :class="{ error: v$.voipPass.$error }"
      :label="$t('PROFILE_SETTINGS.FORM.VOIP.PASS.LABEL')"
      :placeholder="$t('PROFILE_SETTINGS.FORM.VOIP.PASS.PLACEHOLDER')"
      :error="`${v$.voipPass.$error ? $t('PROFILE_SETTINGS.FORM.VOIP.PASS.ERROR') : ''}`"
      @input="v$.voipPass.$touch"
      @blur="v$.voipPass.$touch"
    />
    <div>
      <NextButton
        type="submit"
        :label="$t('PROFILE_SETTINGS.FORM.VOIP.BTN_TEXT')"
      />
    </div>
  </form>
</template>
